import moment from 'moment'
import React, {PureComponent} from 'react'
import ReactTable from 'react-table'
import PropTypes from 'prop-types'

import PageTitle from '../../components/PageTitle'
import DataFetchPage from '../../components/DataFetchPage'
import GoKids from '../../services/GoKids'
import {readPhone} from '../../helpers/format'
import {Button} from 'reactstrap'
import {Link} from 'react-router-dom'

class DriverFamiliesList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  loadFromApi = async () => {
    const driverId = this.props.match.params.id;
    const driver = await GoKids.getDriver(driverId);
    this.setState({driver});
    const families = await GoKids.getDriverFamilies(driverId);
    console.log(families);
    return families;
  };

  render() {
    const {driver} = this.state;
    return (
      <React.Fragment>
        <PageTitle
          title={driver ? driver.fullName : 'Carregando...'}/>
        <DataFetchPage
          className="card card-table"
          fetch={this.loadFromApi}
          renderToolbar={this.renderTopActions}
          renderContent={this.renderContent}/>
      </React.Fragment>
    )
  }

  renderTopActions = ({data, isLoading}) => (
    <div className="card-top-actions">
      <h4>Famílias e crianças registradas</h4>
      <Button tag={Link} to="/maetoristas" color="link">Ver mãetoristas</Button>
    </div>
  );

  renderContent = ({isLoading, data}) => (
    <ReactTable
      loading={isLoading}
      data={data || []}
      columns={[{
        Header: 'Sobre a família',
        columns: [{
          Header: 'Nome',
          accessor: 'name'
        }, {
          Header: 'E-mail',
          accessor: 'email',
        }, {
          Header: 'Telefone',
          className: 'text-center',
          id: 'phone.number',
          accessor: row => row.phone ? readPhone(row.phone.number) : '',
        }]
      }, {
        Header: 'Crianças',
        className: 'text-center',
        id: 'children',
        accessor: row => row.children.length,
      }, {
        Header: 'Data de cadastro',
        className: 'text-center',
        accessor: 'createdAt',
        Cell: ({value}) => moment(value).format('L LT'),
      }]}
      SubComponent={this.renderChildrenContent}
    />
  );

  renderChildrenContent = ({original}) => original.children && original.children.length && (
    <div style={{padding: "20px"}}>
      <ReactTable
        data={original.children}
        columns={[{
          Header: 'Sobre a criança',
          columns: [{
            Header: 'Nome',
            accessor: 'name',
          }, {
            Header: 'Apelido',
            className: 'text-center',
            accessor: 'nickname',
          }, {
            Header: 'Data de nascimento',
            accessor: 'birthday',
            className: 'text-center',
            Cell: ({value}) => value ? moment(value, 'YYYYMMDD').format('DD/MM/YYYY') : '-',
          }]
        }, {
          Header: 'Data de cadastro',
          className: 'text-center',
          accessor: 'createdAt',
          Cell: ({value}) => moment(value).format('L LT'),
        }]}
        minRows={1}
        pageSize={10}
        showPagination={original.children.length > 10}
      />
    </div>
  );
}

DriverFamiliesList.propTypes = {
  //label: PropTypes.string,
};

const styles = {};

export default DriverFamiliesList;



// WEBPACK FOOTER //
// ./src/screens/driver/DriverFamiliesList.js